import { useLayoutEffect } from "react";
import { Outlet } from "react-router";
import { useEntities, useThemeSettings } from "../api/queries";
import { useAppliedTheme } from "../design/useAppliedTheme";
import { CrumbsProvider } from "./crumbs";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { APP_ROOT_ID } from "./useRail";

export function Shell() {
  useLayoutEffect(() => {
    document.body.className = "surface-hub";
  }, []);
  const entities = useEntities();
  const theme = useThemeSettings();
  useAppliedTheme(theme.data);

  return (
    <div className="app" id={APP_ROOT_ID}>
      <Sidebar entityCount={entities.data?.length} />
      <div className="main">
        <CrumbsProvider>
          <Topbar />
          <main className="page">
            <Outlet />
          </main>
        </CrumbsProvider>
      </div>
    </div>
  );
}
